import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { environment } from '@env/environment';
import { Location } from '@angular/common';

@Component({
  selector: 'app-general-terms-of-use',
  templateUrl: './general-terms-of-use.component.html',
  styleUrls: ['./general-terms-of-use.component.scss'],
})
export class GeneralTermsOfUseComponent implements OnInit {
  readonly documentLink: string = `${environment.appLogicStaticWebsiteUrl}${environment.tenant}/anbdocu.html`;
  anbDocumentLink: SafeResourceUrl;

  constructor(
    private sanitizer: DomSanitizer,
    private location: Location,
  ) {
    this.anbDocumentLink = this.sanitizer.bypassSecurityTrustResourceUrl(this.documentLink);
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);
  }

  public goBack(): void {
    this.location.back();
  }
}
